var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 263,
    height: 185,
    viewBox: "0 0 263 185",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12766_213082)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 263,
    height: 185,
    fill: "#111213"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.658 44.0505C163.195 34.8037 177.413 29.5376 192.19 29.039L192.421 35.8851C179.122 36.3338 166.325 41.0733 155.943 49.3955L151.658 44.0505Z",
    fill: "#3A3F47"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_12766_213082)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M194.5 29C207.786 29 220.785 32.8636 231.914 40.1202C243.043 47.3768 251.822 57.7132 257.181 69.8704L250.913 72.6333C246.09 61.6919 238.189 52.3891 228.173 45.8582C218.156 39.3272 206.457 35.85 194.5 35.85V29Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M255.355 128.947C250.713 137.93 244.14 145.774 236.107 151.916C228.074 158.058 218.781 162.346 208.895 164.471C199.008 166.595 188.774 166.505 178.927 164.206C169.08 161.908 159.864 157.457 151.941 151.174L156.197 145.807C163.328 151.461 171.622 155.467 180.485 157.536C189.347 159.605 198.558 159.686 207.455 157.773C216.353 155.861 224.716 152.002 231.946 146.475C239.176 140.947 245.092 133.887 249.27 125.802L255.355 128.947Z",
    fill: "#3A3F47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.579 150.066C143.269 143.958 137.312 136.392 133.091 127.852C128.87 119.311 126.477 109.984 126.064 100.467L132.908 100.17C133.279 108.736 135.433 117.13 139.232 124.817C143.031 132.503 148.392 139.312 154.971 144.81L150.579 150.066Z",
    fill: "#3A3F47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.011 98.738C125.962 96.0006 126.076 93.2627 126.355 90.5391L133.169 91.2352C132.919 93.6864 132.816 96.1505 132.86 98.6142L126.011 98.738Z",
    fill: "#3A3F47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.689 90.9767C263.903 103.667 261.551 116.444 255.9 127.87L249.76 124.833C254.846 114.549 256.962 103.05 255.87 91.629L262.689 90.9767Z",
    fill: "#3A3F47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.948 71.6808C260.275 77.4002 261.819 83.4079 262.536 89.5409L255.732 90.3368C255.087 84.8171 253.698 79.4101 251.603 74.2627L257.948 71.6808Z",
    fill: "#3A3F47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.612 88.3652C128.868 71.6008 137.246 56.264 150.135 45.3084L154.571 50.5275C142.972 60.3876 135.431 74.1907 133.401 89.2787L126.612 88.3652Z",
    fill: "#3A3F47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.415 30.984L240.175 31.624C239.983 31.512 239.639 31.4 239.247 31.4C238.167 31.4 237.487 32.192 237.423 33.256C237.631 32.912 238.103 32.584 238.791 32.584C239.815 32.584 240.567 33.224 240.567 34.352C240.567 35.464 239.663 36.12 238.647 36.12C237.655 36.12 236.623 35.432 236.623 33.72C236.623 31.792 237.783 30.696 239.295 30.696C239.767 30.696 240.175 30.816 240.415 30.984ZM237.535 34.352C237.535 35.032 238.087 35.44 238.655 35.44C239.263 35.44 239.775 35.04 239.775 34.352C239.775 33.656 239.255 33.256 238.655 33.256C238.055 33.256 237.535 33.656 237.535 34.352ZM241.337 35.488C241.337 35.176 241.577 34.928 241.889 34.928C242.201 34.928 242.449 35.176 242.449 35.488C242.449 35.8 242.201 36.04 241.889 36.04C241.577 36.04 241.337 35.8 241.337 35.488ZM244.14 32.68L243.356 32.584C243.348 32.512 243.348 32.44 243.348 32.376C243.348 31.488 244.004 30.696 245.14 30.696C246.252 30.696 246.892 31.424 246.892 32.288C246.892 32.968 246.508 33.512 245.916 33.888L244.892 34.544C244.596 34.736 244.332 34.952 244.26 35.272H246.924V36H243.292C243.308 35.152 243.644 34.504 244.524 33.936L245.388 33.376C245.876 33.064 246.1 32.696 246.1 32.296C246.1 31.824 245.78 31.384 245.124 31.384C244.444 31.384 244.124 31.856 244.124 32.448C244.124 32.52 244.132 32.6 244.14 32.68ZM248.35 32.016C248.35 32.384 248.622 32.648 248.966 32.648C249.318 32.648 249.582 32.384 249.582 32.016C249.582 31.656 249.318 31.392 248.966 31.392C248.622 31.392 248.35 31.656 248.35 32.016ZM247.686 32.016C247.686 31.312 248.278 30.76 248.966 30.76C249.654 30.76 250.254 31.312 250.254 32.016C250.254 32.728 249.654 33.28 248.966 33.28C248.278 33.28 247.686 32.728 247.686 32.016ZM251.518 34.8C251.518 35.168 251.79 35.432 252.134 35.432C252.486 35.432 252.75 35.168 252.75 34.8C252.75 34.44 252.486 34.176 252.134 34.176C251.79 34.176 251.518 34.44 251.518 34.8ZM250.854 34.8C250.854 34.096 251.446 33.544 252.134 33.544C252.822 33.544 253.422 34.096 253.422 34.8C253.422 35.512 252.822 36.064 252.134 36.064C251.446 36.064 250.854 35.512 250.854 34.8ZM249.062 36H248.326L252.054 30.816H252.774L249.062 36Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.899 65.8843C76.8595 64.3129 78.8846 62.8238 80.969 61.4209L86.0221 68.9288C84.1461 70.1914 82.3236 71.5316 80.5591 72.9459L74.899 65.8843Z",
    fill: "#3A3F47"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_12766_213082)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.5 46C149.053 46 166.227 51.1045 180.93 60.6917C195.634 70.2789 207.232 83.935 214.312 99.9966L206.03 103.647C199.658 89.1915 189.22 76.901 175.987 68.2725C162.754 59.644 147.298 55.05 131.5 55.05V46Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M83.0841 60.0399C97.0527 51.1947 113.178 46.3451 129.708 46.0177L129.887 55.066C115.01 55.3606 100.497 59.7252 87.9256 67.6859L83.0841 60.0399Z",
    fill: "#3A3F47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4732 205.949C63.8147 197.879 55.9456 187.883 50.3688 176.6C44.792 165.316 41.6301 152.994 41.0849 140.42L50.1264 140.028C50.617 151.345 53.4628 162.435 58.482 172.59C63.5011 182.745 70.5832 191.741 79.2759 199.004L73.4732 205.949Z",
    fill: "#3A3F47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0148 138.136C40.9494 134.519 41.1009 130.902 41.4685 127.303L50.4716 128.223C50.1408 131.462 50.0045 134.717 50.0633 137.972L41.0148 138.136Z",
    fill: "#3A3F47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.325 102.389C221.251 116.95 223.281 132.804 221.216 148.389C219.15 163.974 213.061 178.752 203.547 191.268L196.342 185.791C204.905 174.527 210.385 161.227 212.244 147.2C214.103 133.174 212.276 118.905 206.943 105.8L215.325 102.389Z",
    fill: "#3A3F47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8083 124.431C44.7886 102.283 55.8584 82.0203 72.8859 67.5461L78.7474 74.4415C63.4226 87.4682 53.4597 105.705 50.7775 125.638L41.8083 124.431Z",
    fill: "#3A3F47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.372 62H194.261V56.7122H192.444V55.9138C193.486 55.8906 194.203 55.3121 194.377 54.5021H195.372V62ZM199.451 62H198.34V56.7122H196.524V55.9138C197.565 55.8906 198.282 55.3121 198.456 54.5021H199.451V62ZM201.01 61.2595C201.01 60.8082 201.358 60.4495 201.809 60.4495C202.26 60.4495 202.619 60.8082 202.619 61.2595C202.619 61.7107 202.26 62.0579 201.809 62.0579C201.358 62.0579 201.01 61.7107 201.01 61.2595ZM203.261 60.3107V59.0032L206.478 54.5021H208.04V59.2577H209.324V60.3107H208.04V62H206.94V60.3107H203.261ZM206.94 59.2577V55.5898L204.302 59.2577H206.94ZM210.984 56.2378C210.984 56.77 211.377 57.1518 211.875 57.1518C212.384 57.1518 212.766 56.77 212.766 56.2378C212.766 55.7171 212.384 55.3352 211.875 55.3352C211.377 55.3352 210.984 55.7171 210.984 56.2378ZM210.023 56.2378C210.023 55.2195 210.88 54.4211 211.875 54.4211C212.87 54.4211 213.738 55.2195 213.738 56.2378C213.738 57.2676 212.87 58.0659 211.875 58.0659C210.88 58.0659 210.023 57.2676 210.023 56.2378ZM215.566 60.2644C215.566 60.7966 215.959 61.1785 216.457 61.1785C216.966 61.1785 217.348 60.7966 217.348 60.2644C217.348 59.7437 216.966 59.3619 216.457 59.3619C215.959 59.3619 215.566 59.7437 215.566 60.2644ZM214.605 60.2644C214.605 59.2462 215.462 58.4478 216.457 58.4478C217.452 58.4478 218.32 59.2462 218.32 60.2644C218.32 61.2942 217.452 62.0926 216.457 62.0926C215.462 62.0926 214.605 61.2942 214.605 60.2644ZM212.014 62H210.949L216.341 54.5021H217.382L212.014 62Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-0.327877 100.154C2.89075 97.489 6.25926 95.0108 9.76112 92.7312L15.735 101.908C12.5833 103.96 9.55168 106.19 6.65491 108.588L-0.327877 100.154Z",
    fill: "#3A3F47"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_12766_213082)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.1322 76.3861C77.1521 72.3668 102.792 77.1498 124.68 89.9196C146.568 102.689 163.349 122.656 172.163 146.414L161.897 150.223C153.964 128.84 138.861 110.871 119.162 99.3777C99.4625 87.8848 76.3869 83.5801 53.8689 87.1975L52.1322 76.3861Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.9194 91.9875C22.9692 84.3573 36.3937 79.1547 50.4384 76.6719L52.3446 87.4547C39.7043 89.6892 27.6223 94.3716 16.7774 101.239L10.9194 91.9875Z",
    fill: "#3A3F47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.502 174.072C180.443 194.358 176.684 214.782 167.65 233.048L157.835 228.193C165.966 211.754 169.349 193.372 167.602 175.115L178.502 174.072Z",
    fill: "#3A3F47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.791 148.151C175.563 156.03 177.425 164.2 178.341 172.502L167.457 173.701C166.633 166.23 164.957 158.877 162.462 151.786L172.791 148.151Z",
    fill: "#3A3F47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-39.022 169.898C-35.4161 143.099 -22.0221 118.583 -1.41976 101.07L5.67221 109.413C-12.8699 125.174 -24.9244 147.239 -28.1698 171.358L-39.022 169.898Z",
    fill: "#3A3F47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.968 92H140.624V85.602H138.426V84.636C139.686 84.608 140.554 83.908 140.764 82.928H141.968V92ZM146.932 86.792C147.898 86.778 148.612 86.19 148.612 85.308C148.612 84.496 147.954 83.852 146.932 83.852C145.91 83.852 145.252 84.496 145.252 85.308C145.252 86.19 145.966 86.778 146.932 86.792ZM146.932 91.02C148.15 91.02 148.836 90.348 148.836 89.494C148.836 88.626 148.136 87.94 146.932 87.94C145.728 87.94 145.028 88.626 145.028 89.494C145.028 90.348 145.714 91.02 146.932 91.02ZM146.932 92.21C144.846 92.21 143.642 91.062 143.642 89.606C143.642 88.5 144.398 87.688 145.364 87.366C144.538 87.058 143.88 86.246 143.88 85.238C143.88 83.754 145.196 82.718 146.932 82.718C148.668 82.718 149.984 83.754 149.984 85.238C149.984 86.218 149.34 87.058 148.5 87.366C149.466 87.674 150.222 88.5 150.222 89.606C150.222 91.062 149.018 92.21 146.932 92.21ZM151.689 91.104C151.689 90.558 152.109 90.124 152.655 90.124C153.201 90.124 153.635 90.558 153.635 91.104C153.635 91.65 153.201 92.07 152.655 92.07C152.109 92.07 151.689 91.65 151.689 91.104ZM155.417 91.678L155.865 90.544C156.257 90.782 156.929 90.978 157.517 90.978C159.715 90.978 160.611 89.536 160.667 87.758C160.345 88.36 159.547 88.92 158.315 88.92C156.747 88.92 155.179 87.856 155.179 85.854C155.179 83.978 156.747 82.718 158.525 82.718C160.303 82.718 162.053 83.992 162.053 86.89C162.053 90.222 160.569 92.21 157.517 92.21C156.817 92.21 155.865 91.986 155.417 91.678ZM160.485 85.826C160.485 84.65 159.519 83.922 158.525 83.922C157.517 83.922 156.565 84.636 156.565 85.826C156.565 87.058 157.489 87.744 158.525 87.744C159.533 87.744 160.485 87.03 160.485 85.826ZM164.412 85.028C164.412 85.672 164.888 86.134 165.49 86.134C166.106 86.134 166.568 85.672 166.568 85.028C166.568 84.398 166.106 83.936 165.49 83.936C164.888 83.936 164.412 84.398 164.412 85.028ZM163.25 85.028C163.25 83.796 164.286 82.83 165.49 82.83C166.694 82.83 167.744 83.796 167.744 85.028C167.744 86.274 166.694 87.24 165.49 87.24C164.286 87.24 163.25 86.274 163.25 85.028ZM169.956 89.9C169.956 90.544 170.432 91.006 171.034 91.006C171.65 91.006 172.112 90.544 172.112 89.9C172.112 89.27 171.65 88.808 171.034 88.808C170.432 88.808 169.956 89.27 169.956 89.9ZM168.794 89.9C168.794 88.668 169.83 87.702 171.034 87.702C172.238 87.702 173.288 88.668 173.288 89.9C173.288 91.146 172.238 92.112 171.034 92.112C169.83 92.112 168.794 91.146 168.794 89.9ZM165.658 92H164.37L170.894 82.928H172.154L165.658 92Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_12766_213082",
    x: 169.705,
    y: -3.23288,
    width: 122.188,
    height: 103.14,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.9589,
    dy: -2.47945
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.8767
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.952941 0 0 0 0 0.239216 0 0 0 0 0.666667 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12766_213082"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12766_213082",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_12766_213082",
    x: 106.705,
    y: 13.7671,
    width: 142.318,
    height: 117.154,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.9589,
    dy: -2.47945
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14.8767
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.952941 0 0 0 0 0.239216 0 0 0 0 0.666667 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12766_213082"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12766_213082",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_12766_213082",
    x: 22.1318,
    y: 36,
    width: 192.031,
    height: 147.223,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.952941 0 0 0 0 0.239216 0 0 0 0 0.666667 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12766_213082"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12766_213082",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12766_213082"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 263,
    height: 185,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.4bbe5445a0b7f6339cf2b79596195a24.svg";
export { ForwardRef as ReactComponent };